import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-chanage-password',
    templateUrl: './chanage-password.component.html',
    styleUrls: ['./chanage-password.component.scss'],
    standalone: false
})
export class ChanagePasswordComponent implements OnInit {
	constructor() {}

	ngOnInit() {}

	public SavePassword(e) {}
}
